// extracted by mini-css-extract-plugin
export default {"container":"ProductFeatures_container__sVDQA container_container__142Ew","title":"ProductFeatures_title__uBr-x"};